import { render, staticRenderFns } from "./TheLogout.vue?vue&type=template&id=a50574ce&scoped=true"
import script from "./TheLogout.vue?vue&type=script&lang=js"
export * from "./TheLogout.vue?vue&type=script&lang=js"
import style0 from "./TheLogout.vue?vue&type=style&index=0&id=a50574ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50574ce",
  null
  
)

export default component.exports